<template>
    <div class="news-container">
        <loader :display="displayLoading"></loader>
        <div class="news" v-for="newsItem in news">
            <a v-bind:href="newsItem.link" target="_blank">
                <img v-bind:src="newsItem.image">
                <div class="news-title">{{newsItem.title}}</div>
                <div class="news-date">{{newsItem.date.format("L")}}</div>
                <span class="news-link">{{$t("news.more")}}</span> <span class="glyphicon glyphicon-menu-right"></span>
            </a>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import config from "../../config";
import loader from "../GlobalSegments/Loader";

export default {
  name: "group-news",
  components: {
    loader
  },
  data: function() {
    return {
      displayLoading: true,
      error: false,
      news: []
    };
  },
  mounted: function() {
    this.$http.get(config.news_url).then(
      response => {
        let newsList = response.body;

        if (
          typeof newsList === "object" &&
          newsList.length > 0 &&
          typeof newsList[0] === "object"
        ) {
          this.displayLoading = false;
          for (let n = 0; n < newsList.length; n++) {
            newsList[n].date = moment(
              newsList[n].date,
              "ddd, DD MMM YYYY HH:mm:ss +-HHmm",
              "en",
              false
            );
          }

          this.news = newsList;
        }
      },
      errorMessage => {
        this.displayLoading = false;
        this.error = true;
      }
    );
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/var";

.news-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .news {
    flex: 0 1 270px;
    max-width: 270px;
    margin-bottom: 15px;

    @include media-phone {
      flex: 0 1 50%;
      padding: 5px;
    }

    &:hover img {
      filter: grayscale(0%);
    }

    img {
      width: 270px;
      filter: grayscale(100%);
      transition: filter 500ms ease;

      @include media-phone {
        width: 100%;
        margin-bottom: 5px;
      }
    }

    .news-title {
      font-family: $condensed_font;
      font-weight: 700;
      font-size: 26px;
    }

    a,
    a:hover {
      color: inherit;
      text-decoration: none;
    }

    .news-link {
      text-decoration: underline;
      margin-bottom: 10px;
    }

    .news-title,
    .news-date,
    a,
    .news-link {
      @include media-phone {
        margin: 0 5px;
      }
    }

    .glyphicon {
      font-size: 15px;

      @include media-phone {
        font-size: 11px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainSegments/GroupNews.vue